import { combineReducers } from "redux";
import data from "./mdmDeviceDataSlice";
import state from "./mdmDeviceStateSlice";

const mdmDeviceReducer = combineReducers({
  data,
  state,
});

export default mdmDeviceReducer;
